// Home.js
import React from "react";
import "../media/css/home.css";

const Home = ({ onSectionChange }) => {
  return (
    <section id="home" className="section-home section-active">
      <div className="container">
        <div className="content">
          <h2>JASON</h2>
          <h1>MARTIN</h1>
          <p>Graphic Designer</p>
          <div className="btns">
            <button className="resume-btn" onClick={() => onSectionChange(2)}>
              Resume
            </button>
            <button
              className="portfolio-btn"
              onClick={() => onSectionChange(3)}
            >
              Portfolio
            </button>
          </div>
        </div>
        <div className="social">
          <a href="#">
            <i className="bi bi-behance"></i>
          </a>
          <a href="#">
            <i className="bi bi-facebook"></i>
          </a>
          <a href="#">
            <i className="bi bi-linkedin"></i>
          </a>
          <a href="#">
            <i className="bi bi-instagram"></i>
          </a>
          <a href="#">
            <i className="bi bi-pinterest"></i>
          </a>
          <a href="#">
            <i className="bi bi-twitter"></i>
          </a>
          <a href="#">
            <i className="bi bi-whatsapp"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
